module.exports = __webpack_public_path__ + "static/media/call-quality-fair.ef31e7f5.svg";